'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["DescriptionListComponent", "baseFilterFamily", "className", "style", "value"];
import * as FilterQueryFormat from 'customer-data-filters/filterQueryFormat/FilterQueryFormat';
import FilterEditorOperatorDescriptionGroup from './FilterEditorOperatorDescriptionGroup';
import FilterType from '../propTypes/FilterType';
import PropTypes from 'prop-types';
import { memo, useMemo } from 'react';
import UIList from 'UIComponents/list/UIList';
import memoize from 'transmute/memoize';
import { jsx as _jsx } from "react/jsx-runtime";
const groupFilterFamilies = memoize((baseFilterFamily, descriptions) => descriptions.groupBy(description => description.filterFamily).sort((a, b) => {
  if (a.first().filterFamily === baseFilterFamily) {
    return -1;
  } else if (b.first().filterFamily === baseFilterFamily) {
    return 1;
  }
  return 0;
}));
const FilterEditorOperatorDescriptionList = props => {
  const {
      DescriptionListComponent,
      baseFilterFamily,
      className,
      style,
      value
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const dataAttributes = Object.keys(rest).filter(key => key.startsWith('data-')).reduce((acc, key) => {
    acc[key] = rest[key];
    return acc;
  }, {});
  const operatorDescriptions = useMemo(() => {
    return FilterQueryFormat.getFilterDescription(value, baseFilterFamily);
  }, [baseFilterFamily, value]);
  const filterFamilyGroups = groupFilterFamilies(baseFilterFamily, operatorDescriptions);
  const listComponentProps = DescriptionListComponent === UIList ? {} : {
    descriptions: operatorDescriptions
  };
  return /*#__PURE__*/_jsx("div", Object.assign({}, dataAttributes, {
    className: className,
    "data-selenium-test": "XOFilterEditor-operator-descriptionList",
    style: style,
    children: /*#__PURE__*/_jsx(DescriptionListComponent, Object.assign({}, listComponentProps, {
      children: filterFamilyGroups.reduce((acc, descriptions, filterFamily) => {
        const descriptionGroup = /*#__PURE__*/_jsx(FilterEditorOperatorDescriptionGroup, Object.assign({
          baseFilterFamily: baseFilterFamily,
          descriptions: descriptions,
          filterFamily: filterFamily
        }, rest), filterFamily);
        acc.push(descriptionGroup);
        return acc;
      }, [])
    }))
  }));
};
FilterEditorOperatorDescriptionList.propTypes = {
  DescriptionListComponent: PropTypes.elementType.isRequired,
  baseFilterFamily: PropTypes.string.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  value: FilterType.isRequired
};
export default /*#__PURE__*/memo(FilterEditorOperatorDescriptionList);